"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash-es/noop"));
const isNil_1 = __importDefault(require("lodash-es/isNil"));
const useRefsCompose_1 = __importDefault(require("../../../../utils/hooks/useRefsCompose"));
// eslint-disable-next-line import/order
const useSyncState_1 = __importStar(require("../../../../utils/hooks/useSyncState"));
// eslint-disable-next-line import/no-cycle
const InputText_1 = __importDefault(require("../InputText"));
const __1 = require("../..");
const getInputNumberFormatState_1 = __importDefault(require("./utils/getInputNumberFormatState"));
const hasRef = (ref) => Boolean(ref && ref.current);
const InputNumber = react_1.default.forwardRef(({ value: propsValue, onChange = noop_1.default, onBlur = noop_1.default, onValid = noop_1.default, min, max, precision, cast = Number, decimalSeparator, thousandsSeparator, ...props }, ref) => {
    const innerRef = (0, react_1.useRef)(null);
    const [params, setParam] = (0, useSyncState_1.default)({
        precision,
        min,
        max,
        cast,
        decimalSeparator,
        thousandsSeparator,
    });
    (0, react_1.useEffect)(() => {
        setParam({
            precision,
            min,
            max,
            cast,
            decimalSeparator,
            thousandsSeparator,
        });
    }, [precision, min, max, cast, decimalSeparator, thousandsSeparator]);
    const stringPropsValue = String((0, isNil_1.default)(propsValue) ? '' : propsValue);
    const [viewState, setViewState] = (0, useSyncState_1.default)(() => (0, getInputNumberFormatState_1.default)({
        input: stringPropsValue,
        finished: true,
        ...params,
    }), (0, react_1.useCallback)(({ correct, value, viewValue, event }) => {
        if (correct && String(value) !== stringPropsValue) {
            onChange(value, event);
        }
        // set input value in sync way to prevent any race
        if (hasRef(innerRef)) {
            innerRef.current.value = viewValue;
        }
    }, [onChange, stringPropsValue]), useSyncState_1.shallowEqualityCheck);
    (0, react_1.useEffect)(() => {
        setViewState((0, getInputNumberFormatState_1.default)({
            input: stringPropsValue,
            ...params,
            finished: stringPropsValue !== viewState.viewValue,
        }), true);
    }, [stringPropsValue, setViewState]);
    const handleChange = (0, react_1.useCallback)((input, event) => {
        setViewState((0, getInputNumberFormatState_1.default)({
            input,
            ...params,
            finished: false,
            event,
        }), true);
    }, [setViewState]);
    const handleBlur = (0, react_1.useCallback)((event) => {
        setViewState((0, getInputNumberFormatState_1.default)({
            input: viewState.viewValue,
            ...params,
            finished: true,
        }));
        onBlur(event);
    }, [onBlur, viewState.viewValue, setViewState]);
    const handleValid = (0, react_1.useCallback)((value) => {
        onValid(Number(value));
    }, [onValid]);
    return ((0, jsx_runtime_1.jsx)(InputText_1.default, { ...props, value: String(propsValue), type: __1.InputType.Text, ref: (0, useRefsCompose_1.default)(ref, innerRef), uncontrolled: true, onChange: handleChange, onBlur: handleBlur, onValid: handleValid }));
});
exports.default = InputNumber;
